import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';


import { getRouteByName } from 'Helpers/Routes';

import Button from 'Components/layout/Button';
import AuthWrapper from 'Components/helpers/wrappers/AuthWrapper';

@connect(
    (state) => ({
        purchasePhotosPolicy: state.user.currentPolicies.purchasePhotos
    }), {}
)
export default class SinglePhotoPhotoSectionCheckoutPricing extends React.Component {
    static propTypes = {
        purchasePhotosPolicy: PropTypes.bool.isRequired,
        photo: PropTypes.shape({
            price: PropTypes.number.isRequired,
            isInLightbox: PropTypes.bool,
            isInCart: PropTypes.bool,
            downloadUrl: PropTypes.string
        }).isRequired,
        onAddToCart: PropTypes.func.isRequired,
        onAddToLightbox: PropTypes.func.isRequired,
        onRemoveFromLightbox: PropTypes.func.isRequired,
        currentBrandId: PropTypes.string,
        creditsCount: PropTypes.number
    };
    static defaultProps = {
        creditsCount: 0
    }

    renderButton = () => {
        const { onAddToCart, onAddToLightbox, onRemoveFromLightbox, purchasePhotosPolicy } = this.props;
        const { isInLightbox, isInCart, downloadUrl } = this.props.photo;
        if (downloadUrl) {
            return (
                <Button element="anchor" to={downloadUrl} target="_self">
                    <span>{I18n.t('SINGLE_PHOTO.checkout.alreadyBought')}</span>
                </Button>
            );
        } else {
            return (
                <div>
                    {purchasePhotosPolicy ?
                        isInCart ?
                            <Button element="anchor" className="animated bounceIn" to={getRouteByName('cart').path} id="view-cart">
                                <span>View cart</span>
                            </Button>
                            :
                            <Button disabled={isInCart} onClick={this.props.onAddToCart} id="add-to-cart">
                                <span>{isInCart ? I18n.t('SINGLE_PHOTO.checkout.addedToCart') : I18n.t('SINGLE_PHOTO.checkout.addToCart')}</span>
                            </Button>
                        : null}
                    <AuthWrapper profile={true}>
                        {isInLightbox ?
                            <a className="lightbox-link" onClick={onRemoveFromLightbox} id="remove-from-lightbox">Remove from lightbox</a>
                            : <a className="lightbox-link" onClick={onAddToLightbox} id="add-to-lightbox">Add to lightbox</a>
                        }
                    </AuthWrapper>
                </div>
            );
        }
    }

    renderPrice = () => {
        const { creditsCount } = this.props;
        const { price } = this.props.photo;

        if (creditsCount >= price) {
            return (
                <p className="price">
                    {price} <small>credits</small>
                </p>
            );
        } else {
            return (
                <p className="price">
                    <sup>$</sup>{price.toFixed(2)}
                </p>
            );
        }
    }

    render() {
        const { currentBrandId } = this.props;
        const { downloadUrl } = this.props.photo;

        return (
            <div className="single-photo-photo-section-checkout-pricing">
                <div className="row">
                    {
                        currentBrandId || downloadUrl ? null :
                            <div className="col col-price pull-left">
                                {this.renderPrice()}
                            </div>
                    }
                    <div className={`col col-button col-button-small pull-right ${currentBrandId || downloadUrl ? 'wide' : ''}`}>
                        {this.renderButton()}
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/public/single-photo/Photo/components/CheckoutPricing/index.js